/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Master {

    @Serenity.Decorators.registerClass()
    export class LinkbantuanGrid extends NoboxEntityGrid<LinkbantuanRow, any> {
        protected getColumnsKey() { return LinkbantuanColumns.columnsKey; }
        protected getDialogType() { return LinkbantuanDialog; }
        protected getIdProperty() { return LinkbantuanRow.idProperty; }
        protected getInsertPermission() { return LinkbantuanRow.insertPermission; }
        protected getLocalTextPrefix() { return LinkbantuanRow.localTextPrefix; }
        protected getService() { return LinkbantuanService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            Q.first(columns, x => x.field == LinkbantuanRow.Fields.Url).format =
                ctx => `<a href="${'https://crm.nobox.ai/' + ctx.value}" target="_blank">${Q.htmlEncode(ctx.value)}</a>`;
            return columns;
        }
    }
}